import React, { useCallback, useEffect, useState } from 'react';
import { Text, CustomImage, CustomModal, useText } from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import '../payWithNewCard/payWithNewCard.scss';
import { Header } from '@src/components/CustomDialog';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';
import { Radio } from 'antd';
import CustomButton from '@src/components/CustomButton';
import PropTypes from 'prop-types';

const PayWithNewCardCompliments = ({ setModalVisible, form, clickHandler, selectedIndex }) => {
  const [value, setValue] = useState(0);

  const attentionText = useText('attention');

  useEffect(async () => {
    if (selectedIndex) {
      setValue(1);
    }
  }, [selectedIndex]);

  const handler = async () => {
    if (value === 1) {
      try {
        await form.setFieldsValue({
          cardSaveChecked: true,
        });
        await form.validateFields();
        setModalVisible(false, 1);
        clickHandler(value);
      } catch (e) {
        console.error(e);
        setModalVisible(false, 1);
      }
    } else {
      setModalVisible(false, 2);
      clickHandler(value);
    }
  };

  const onChange = useCallback(
    async (e) => {
      setValue(e.target.value);
      if (e.target.value === 1) await form.validateFields();
    },
    [value],
  );

  return (
    <CustomModal
      className="pay-with-new-card"
      width={583}
      maskClosable={false}
      footer={false}
      title={<Header title={attentionText} type={'warning'} icon={modalWarning}></Header>}
      visible={true}
      onCancel={async () => {
        setModalVisible(false);
      }}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className={'modal-inner-container'}>
        <Radio.Group
          id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radioGroup-input-content"
          onChange={onChange}
          value={value}
          className="custom-radio-input-content"
        >
          <Radio
            id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content1"
            value={1}
            style={{ marginBottom: 10 }}
            className={value === 2 ? 'ant-radio-wrapper-unchecked' : null}
          >
            <div className="credit-card-title" style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="compliments-bold-text" style={{ marginBottom: 2 }}>
                <Text t="saveMyCardAutomaticallyCollectOnPaymentDay" />
              </span>
              <Text t="yourCardInformationIsStoredSecurelyAndPayment" />
            </div>
          </Radio>
          <Radio
            id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content2"
            value={2}
            className={value === 1 ? 'ant-radio-wrapper-unchecked' : null}
          >
            <div
              className="eftTransfer-card-title"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <span className="compliments-bold-text" style={{ marginBottom: 2 }}>
                <Text t="donTSaveMyCardSendMeA" />
              </span>
              <Text t="yourCardInformationIsNotStoredOnThe" />
              <Text t="aPaymentLinkWillBeSentToYour" />
            </div>
          </Radio>
        </Radio.Group>
        <CustomButton
          id="ticketRestaurant-paymentModals-payWithNewCardCompliments-payWithNewCardCompliments-pay-now"
          disabled={value === 0}
          className="pay-now"
          onClick={() => handler()}
        >
          <Text t="continue2" />
        </CustomButton>
      </div>
    </CustomModal>
  );
};

PayWithNewCardCompliments.propTypes = {
  setModalVisible: PropTypes.func,
  orderDate: PropTypes.any,
  form: PropTypes.any,
  clickHandler: PropTypes.func,
  selectedIndex: PropTypes.any,
};
export default PayWithNewCardCompliments;
